import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './OliveShell.scss';
import './Login.scss';
import Splash from './Splash';
import { LoginModel } from './LoginModel';
import { login } from '../Services/Users.service';
import Loader from '../Components/common/loader/loader';
import { useDispatch } from 'react-redux';
import { useAuth } from '../contexts/AuthContext';

const UsernameInput = lazy(() => import('./UsernameInput'));
const PasswordInput = lazy(() => import('./PasswordInput'));

interface LoginProps {
  onLogin?: (status: boolean) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const { login: authLogin } = useAuth();
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get('ref');

  useEffect(() => {
    setIsLoading(true);
    const userCredentials: LoginModel = {
      grantType: 'form',
      refreshToken: '',
      reference: ref != null ? ref : "",
      referencetoken: ''
    };

    login(userCredentials).then((response) => {
      if (response != null && typeof response === 'object' && response.status === "success") {
        // Use the auth context login instead
        if (response.accessToken) {
          authLogin(response.accessToken, response.refreshToken);
        }
        
        if (onLogin) {
          onLogin(true);
        }
        navigate('/home');
      } else {
        setIsLoading(false);
      }
    }).catch((error) => {
      console.error("Login failed:", error);
      setIsLoading(false);
    });
  }, [ref, navigate, onLogin, dispatch, authLogin]);

  return (
    <Suspense fallback={<Loader />}></Suspense>
  )
};

export default Login;
